import { useState } from 'react';
import { useAccessibility } from '../../context/AccessibilityContext/AccessibilityContext';
import style from './newscard.module.scss';

const NewsCard = ({ id, title, text, image, date, width, height, onClick }) => {
    const { settings: { contrast } } = useAccessibility();
    const [imageError, setImageError] = useState(false);

    const config = {
        width: width || '100%',
        height: height || '100%',
        '--card-bg': contrast !== 'default' ? 'var(--bg-primary)' : '#ffffff',
        '--text-color': contrast !== 'default' ? 'var(--text-primary)' : '#1a1a2e',
        '--date-color': contrast !== 'default' ? 'var(--text-primary)' : '#0032a0'
    };

    const handleKeyPress = (e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onClick();
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '12.06.2025';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch {
            return '12.06.2025';
        }
    };

    const getImageSrc = () => {
        if (imageError || !image) {
            return null;
        }
        return image;
    };

    return (
        <article
            className={style.newscard}
            style={config}
            aria-labelledby={`news-${id}-title`}
            onClick={onClick}
            onKeyDown={onClick ? handleKeyPress : undefined}
            tabIndex={onClick ? 0 : -1}
            role={onClick ? 'button' : 'article'}
        >
            {getImageSrc() ? (
                <img
                    className={style.image}
                    src={getImageSrc()}
                    alt={title || 'Новость'}
                    loading="lazy"
                    onError={() => setImageError(true)}
                />
            ) : (
                <div className={style.imagePlaceholder}>
                    <span>📰</span>
                </div>
            )}
            
            <span className={style.date}>
                {formatDate(date)}
            </span>
            
            <h4 className={style.title} id={`news-${id}-title`}>
                {title || 'Заголовок'}
            </h4>
            
            <p className={style.text}>
                {text || 'Описание...'}
            </p>
        </article>
    );
};

export default NewsCard;